import { select, call, put, takeLatest } from 'redux-saga/effects'
import {fetchContent} from "../api"
import {LOAD_MORE_ARTICLES_REQUEST, LOAD_MORE_ARTICLES_SUCCESSFUL, LOAD_MORE_ARTICLES_ERROR} from "../actions"
import {getCurrentLocation, getArticlesContent, getCurrentPageContent, getExperimentRef} from "../selectors"
import {isHomePath, stripBasePath} from '../utils/pages'
import get from 'lodash/get'

function* fetchMore(action) {
    try {
        const location = yield select(getCurrentLocation);
        const page = yield select(getCurrentPageContent);
        const articles = yield select(getArticlesContent);
        const experimentRef = yield select(getExperimentRef);

        var fetchQuery = {
            ...location,
            query: {
                ...location.query,
                page: page.landing_page_uid === articles.landing_page_uid ? articles.page + 1 : 1,
                ref: experimentRef
            }
        };

        if (page.type === 'article') {
            fetchQuery.query.tags = get(page, ["tags"], [])
        }

        let path = fetchQuery.pathname
        if(isHomePath(path)) path = '/today'
        else path = `/articles${stripBasePath(fetchQuery.pathname)}`

        const content = yield call(fetchContent, path, fetchQuery.query);
        yield put({type: LOAD_MORE_ARTICLES_SUCCESSFUL, payload: { content: content } });
    } catch (e) {
        console.error(e);
        yield put({type: LOAD_MORE_ARTICLES_ERROR, message: e.message});
    }
}

function* loadMoreSaga() {
    yield takeLatest(LOAD_MORE_ARTICLES_REQUEST, fetchMore);
}

export default loadMoreSaga;


// WEBPACK FOOTER //
// ./src/sagas/articles.js